<template>
<div class="pa-3 full-width" style="max-width:800px;">
    <div class="display-flex">
        <div style="flex-grow:1;font-size:24px;color:#888">
            {{formatMillions(totalAmount)}}
            <LabelMenu labelClass="heading" v-model="dateFilter" :menus="[
                {value: 'active', text:'Active'},
                {value: 'settlement_confirmed_date', text: 'Settlements'}, 
                {value: 'approved_date', text:'Approvals'},
                {value: 'submitted_date', text:'Submissions'},
                {value: 'lead_taken_date', text:'Leads Taken'},
            ]" />
            <div style="font-size:16px">{{filteredLoanCount}} Deals Shown</div>
        </div>

        <div class="mr-3 ml-3">
            <v-text-field v-model="search" label="Search..." />
        </div>

        <DateRange v-if="dateFilter !== 'active'" v-model="dateRange"/>
    </div>

    <div class="elevation-1 white pa-3 mb-4 rounded">
        
   
        <!-- <div style="position:relative;background-color:red;"> -->

        <GChart v-if="dateFilter == 'active'" class="g-chart"
            type="PieChart"
            :data="lenderSpread"
            :options="googleChartOptions"
        />
        <!-- </div> -->
  

        <table style="width:100%">
            <tr v-for="loan in filteredLoans" :key="loan.meta.key">
                <td>
                    <a :href="transactionLink(loan.meta.key)" target="_blank" class="transparent">
                        {{clientNames(loan.clients)}}
                    </a>
                </td>
                <td>
                    {{loan[dateFilter] | date}}
                </td>
                <td style="display:flex;">
                    <img :src="'/static/images/lenders/' + loan.lender + '.jpg'" alt="" width="50" style="margin:0 15px 3px 5px;"/>
                    <div>{{loan.lender}}</div>
                </td>
                <td>
                    {{fullName(loan.broker)}}
                </td>
                <td>
                    {{loan.total_new_money | currency}}
                </td>
            </tr>
        </table>


    </div>



    
    <NoRecordsPlaceholder v-if="false">
        No Records
    </NoRecordsPlaceholder>  

</div>
</template>

<script>
import Utilities from '../../helpers/Utilities'
import DataHelpers from '../../helpers/DataHelpers'
import ContactHelpers from '../../helpers/ContactHelpers'
import TeamHelpers from '../../helpers/TeamHelpers'
import NiceData from '../../data/NiceData'
import ChartControl from './ChartControl'
import DateHelpers from '../../helpers/DateHelpers'
import ImageGroup from '../../ui-elements/ImageGroup'
import NoRecordsPlaceholder from '../../ui-elements/NoRecordsPlaceholder'
import DateRange from '../../ui-elements/DateRange'
import LabelMenu from '../../ui-elements/LabelMenu'

import {subMonths, startOfMonth, endOfMonth, getDaysInMonth, getDate} from 'date-fns'

// import { format } from 'date-fns'
export default {
name: 'RangeChart',
props: {
    tenantKey: String,
    chart: Object
},
components: {
    ImageGroup, NoRecordsPlaceholder, DateRange, LabelMenu
},

data() {
return {
    search: '',
    dateFilter: 'active',
    // dateFilter: 'settlement_confirmed_date',
    dateRange: {
        start: startOfMonth(new Date()),
        end: endOfMonth(new Date())
    },
    transactions: {},
    loans: [],
    settledThisMonth: [],
    daysThisMonth: 30,
    dayOfMonth: 1,

}
},

asyncComputed: {
    officeName: {
      async get () {
        return TeamHelpers.officeNumberToName(this.tenantKey)
      },
      default: ''
    }
},


computed:{
    filteredLoans() {
        if(this.search) {
            const s = this.search.toLowerCase()
            return this.loans.filter(o =>
                (o.broker ? o.broker.firstName.toLowerCase() : '').indexOf(s) > -1 ||
                (o.broker ? o.broker.lastName.toLowerCase() : '').indexOf(s) > -1 ||
                (o.lender ? o.lender.toLowerCase() : '').indexOf(s) > -1
                
            )
        } else {
            return this.loans
        }
    },

    googleChartOptions() {
        return {
            legend: 'labeled',
            colors: this.chartColours,
            height: 200,
            width: 400,
        }
    },



    lenderSpread() {
        let spread = {}
        this.filteredLoans.forEach( (loan) => {
            const lender = loan.lender
            spread[lender] = (spread[lender] || 0) + 1
        })
        let chartData = []
        for(let key in spread) {
            const rowArray = [key, spread[key]]
            chartData.push(rowArray)
        }
        chartData.sort(function(a, b) {
            return b[1] - a[1]
        })

        while(chartData.length > 6) {
            chartData.pop()
        }

        chartData.unshift( ['Lender', 'Count'] )
        return chartData
    },

    chartColours() {
        let colours = []
        for(let i = 1; i < this.lenderSpread.length; i++) {
            const lender = this.lenderSpread[i][0]
            const colour = this.getLenderColour(lender)
            colours.push(colour)
        }
        return colours
    },

    filteredLoanCount() {
        return this.filteredLoans.length
    },
        
    startingDate() {
        return DateHelpers.dateToBackwards(this.dateRange.start)
    },
    endingDate() {
        return DateHelpers.dateToBackwards(this.dateRange.end)
    },

    totalAmount() {
        return this.totalNewMoney(this.filteredLoans)
    },
    triggers() {
        return {
            filter: this.dateFilter,
            range: this.dateRange,
        }
    }
},
methods: {

    getLenderColour(lender) {
        const colours = [
            {lender:'CBA', colour: '#ffcc00',}, 
            {lender:'ANZ', colour: '#007dba',}, 
            {lender:'Westpac', colour: '#990000',}, 
            {lender:'NAB', colour: '#c20000'},
            {lender:'Macquarie', colour: '#000000'},
            {lender:'Bankwest', colour: '#ff911e'},
            {lender:'CUA', colour: '#00a0b9'},
            {lender:'Me Bank', colour: '#000000'},
            {lender:'St George', colour: '#78be20'},
            {lender:'Gateway', colour: '#002B54'},
            {lender:'HSBC', colour: '#db0011'},
            {lender:'Mortgage Choice Home Loans', colour: '#007491'},
            {lender:'Suncorp', colour: '#478081'},
            {lender:'Aussie Select', colour: '#6610f2'},

        ]
        const obj = colours.find(o => o.lender == lender)
        return (obj ? obj.colour : '#999999')
    },
    
    fullName(contact) {
        return ContactHelpers.fullName(contact)
    },

    formatMillions(amt) {
        return '$' + Math.round(amt / 10000) / 100 + 'm'
    },


    transactionLink(transactionKey) {
        return '/' + this.tenantKey + '/transaction/' + transactionKey
    },

    clientImages(clientsObj) {
        const clients = Utilities.objectToObjectArray(clientsObj)
        const images = clients.map(o => o.image)
        return images
    },
    clientNames(clientsObj) {
        const clients = Utilities.objectToObjectArray(clientsObj)
        const names = ContactHelpers.combineClientsNames(clients) 
        return names
    },

    totalNewMoney(arr) {
        if(!arr || arr.length == 0)
            return 0
        return arr.reduce(function(a, b) {
            return a + (b.total_new_money || 0)
        }, 0)
    },

    fetchRecords() {
        const milestoneRef = DataHelpers.getTenantRef(this.tenantKey).child('milestones')
        let loansRef
        if(this.dateFilter == 'active')
            loansRef = milestoneRef.orderByChild('active').equalTo(true)
        else
            loansRef = milestoneRef.orderByChild(this.dateFilter).startAt(this.startingDate).endAt(this.endingDate).limitToLast(500)
        
        NiceData.fetchItemsFromFirebase(loansRef).then(items => {
            this.loans = items
        })
    }


},

created() {
   
},

watch: {
    'dateRange': {
        handler: function() {
            this.fetchRecords()
        },
        deep: true,
    },
    'dateFilter': {
        handler: function() {
            this.fetchRecords()
        },
        immediate: true,
    },
}

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  

    .date-section {
        display:flex;flex-wrap:wrap;background-color:#f0f0f0;padding:15px;border-radius:7px
    }
    .date-card {
        border-radius:7px;width:350px; height:150px;margin:8px;margin-top:22px;text-align:center;background-color:white;    
    }
    .date-bar {
        height:4px;width:300px;margin:10px auto;border-radius:3px;
    }
    .chart-outline {
        min-width:100%;
        margin-top:-35px;
    }
    .chart-header {
        width:100%;font-weight: bold; padding:10px;
        color:#888; height:35px;
    }
    .chart-row {
        width:100%;
    }
    .chart-column {
        padding:1px; flex-grow: 1;
    }
    .chart-cell {
        /* background-color: #eee; */
        height:60px;
    }
    .chart-heading {
        font-size:28px;
        color:rgb(5, 116, 150);
    }

    td {
        padding: 3px;
    }

</style>


// WEBPACK FOOTER //
// RangeChart.vue?7c45b5dc